import { useMutation } from "@tanstack/react-query";
import {
  getApiUrl,
  getMerchantsPublicIDOrbitLContractPath,
  type OrbitLContractType,
} from "Infrastructure/Api/Api";
import { JWT_KEY } from "Utils/AuthUtils";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import { format } from "date-fns";
import FileSaver from "file-saver";

type Parameters = {
  merchantPublicID: string;
  contractType: OrbitLContractType;
  fileNamePrefix: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDownloadOrbitLContractMutation = ({
  onSuccess,
  onError,
}: Props = {}) =>
  useMutation({
    mutationFn: async ({
      merchantPublicID,
      contractType,
      fileNamePrefix,
    }: Parameters) => {
      const route = `${getApiUrl()}${getMerchantsPublicIDOrbitLContractPath(merchantPublicID)}?contractType=${contractType}`;
      const response = await fetch(route, {
        method: "GET",
        mode: "cors",
        headers: { Authorization: getLocalStorageItem(JWT_KEY) ?? "" },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const byteCharacters = atob(data.bytes);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileName = `${fileNamePrefix}_${format(new Date(), "yyyy-MM-dd")}.pdf`;
      FileSaver.saveAs(blob, fileName);
    },
    onSuccess,
    onError,
  });
